import SearchPage from './screens/SearchPage';


const routes = [
       
    {
      path: "/search",
      exact: true,
      name: "Buscar",
      component: SearchPage,
      icon: "fa fa-search",
      layout: "/admin",
      sidebar: true,
      roleID: 'SEARCH'
    } 
  ];
  
  export default routes;

